import { MediaItemFile } from "@rapid/types/media";
import {
    UploadLimitErrorType,
    MAX_IMAGES_PER_UPLOAD,
    MAX_VIDEOS_PER_UPLOAD,
    MAX_FILE_SIZE_BYTES
} from "@rapid/constants/media";

const VIDEO_EXTENSIONS = [
    ".mp4",
    ".webm",
    ".mov",
    ".avi",
    ".mkv",
    ".wmv",
    ".flv",
    ".m4v",
    ".3gp",
    ".3g2",
    ".ogv",
    ".ts",
    ".mts",
    ".asf",
    ".divx",
    ".dv",
    ".rv",
    ".vob"
];

/**
 * Check if a file is a video based on MIME type or file extension
 */
function isVideoFile(file: MediaItemFile): boolean {
    if (file.type.startsWith("video/")) {
        return true;
    }

    const extension = `.${file.name.split(".").pop()?.toLowerCase()}`;
    return VIDEO_EXTENSIONS.includes(extension);
}

/**
 * Validates upload limits for media files
 * @param files - Array of files to validate
 * @returns UploadLimitErrorType if validation fails, null if all checks pass
 */
export function validateUploadLimits(files: MediaItemFile[]): UploadLimitErrorType | null {
    // Separate videos and images
    const videos = files.filter(isVideoFile);
    const images = files.filter((file) => !videos.includes(file));

    // Check for file size limit
    const oversizedFiles = files.filter((file) => file.size > MAX_FILE_SIZE_BYTES);
    if (oversizedFiles.length > 0) {
        return UploadLimitErrorType.FILE_TOO_LARGE;
    }

    // Check for mixed content
    if (videos.length > 0 && images.length > 0) {
        return UploadLimitErrorType.MIXED_CONTENT;
    }

    // Check video limit
    if (videos.length > MAX_VIDEOS_PER_UPLOAD) {
        return UploadLimitErrorType.TOO_MANY_VIDEOS;
    }

    // Check image limit
    if (images.length > MAX_IMAGES_PER_UPLOAD) {
        return UploadLimitErrorType.TOO_MANY_IMAGES;
    }

    return null;
}
